/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { get } from 'js/lib/cookie';

import { Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import { getActionUrl } from 'bundles/user-account/common/lib';

import _t from 'i18n!nls/composable-page-header';

type Props = {
  tabIndex: number;
};

const styles = {
  logOutButton: css`
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: left;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--cds-color-neutral-primary);
    padding: 0;
  `,
  li: css`
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: left;
    position: relative;
    padding: var(--cds-spacing-100);
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
};

const MobileLogOutButton = (props: Props) => {
  const csrfToken = get('CSRF3-Token');
  const { tabIndex } = props;

  return (
    <li css={styles.li}>
      <form action={getActionUrl('logout', csrfToken || '')} method="post">
        <TrackedButton
          role="menuitem"
          type="submit"
          data-popup-close
          trackingName="mobile_header_sign_out_button"
          data={{ name: 'sign-out' }}
          aria-label={_t('Sign Out')}
          tabIndex={tabIndex}
          css={styles.logOutButton}
        >
          <Typography2 variant="bodyPrimary" component="p">
            {_t('Log Out')}
          </Typography2>
        </TrackedButton>
      </form>
    </li>
  );
};

export default MobileLogOutButton;
